const behaveMapping = [
  {
    indicator: 'indicatorEqualCreditDebit',
    info: 'Equal Credit and Debit Amounts',
    details: 'Total credits and debits in the account are consistently equal.',
  },
  {
    indicator: 'indicatorNegativeEod',
    info: 'Negative End of Day Balance',
    details: 'Account balance at the end of the day is negative.',
  },
  {
    indicator: 'indicatorBigDebitAfterSalary',
    info: 'Large Debit After Salary Credit',
    details:
      'Significant debit transaction occurs immediately after a salary credit.',
  },
  {
    indicator: 'indicatorCashDepositAboveSalary',
    info: 'Cash Deposit Above Salary Credit',
    details: 'Cash deposit into the account exceeds the salary credit amount.',
  },
  {
    indicator: 'indicatorIrregularInterestCharges',
    info: 'Irregular Interest Charges',
    details: 'Irregular or unexpected interest charges applied to the account.',
  },
  {
    indicator: 'indicatorIrregularSalaryCredits',
    info: 'Irregular Salary Credits',
    details:
      'Irregular patterns or inconsistencies in the salary credits received.',
  },
  {
    indicator: 'indicatorRecentNoSalaryCredits',
    info: 'Recent Lack of Salary Credits',
    details: 'No salary credits received into the account for a recent period.',
  },
  {
    indicator: 'indicatorRoundFigureTax',
    info: 'Round Figure Tax Payments',
    details:
      'Tax payments or deductions consistently rounded to whole numbers or specific amounts.',
  },
  {
    indicator: 'indicatorIrregualrTransferToParties',
    info: 'Irregular Transfers to Parties',
    details:
      'Irregular or unauthorized transfers made to third parties or external accounts.',
  },
  {
    indicator: 'indicatorUnchangedSalaryCredits',
    info: 'Unchanged Salary Credits',
    details:
      'No changes in the salary credits received into the account over a specified period.',
  },
  {
    indicator: 'indicatorPartiesPresentInBothDebitAndCredit',
    info: 'Parties Present in Both Debit and Credit Transactions',
    details:
      'Same parties or entities appear in both the debit and credit transactions of an account.',
  },
  {
    indicator: 'indicatorDiscontinuityCredits',
    info: 'Discontinuity in Credits',
    details:
      'Significant discontinuities or gaps in the credits received into the account.',
  },
  {
    indicator: 'indicatorDemographicEarning',
    info: 'Mismatch in Demographic and Earning Information',
    details:
      "Significant mismatch between the account holder's demographic information and reported earnings.",
  },
  {
    indicator: 'indicatorManyCashTxn',
    info: 'Many Cash Transactions',
    details: 'Large number of cash transactions within a specific time period.',
  },
  {
    indicator: 'indicatorOdTaken',
    info: 'Overdraft Facility Taken',
    details:
      'Overdraft (OD) facility has been taken or utilized in the account.',
  },
];

export default behaveMapping;
